/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpService } from "../../http.service";
import { NgxSpinnerService } from "ngx-spinner";
import { environment } from "../../../environments/environment";
import { BehaviorSubject, Observable } from "rxjs";
import { ImageDrawingInfo } from "../views/two-dview/twoDViewModels";
import { TwoDService } from "../views/two-dview/two-d.service";
import { UserService } from "../user-management/user.service";
import { MarkersColorsService } from "./markers-colors.service";
import { AtlasSharedService } from "../atlas-shared.service";
import { AlertService } from "../../alert.service";
import { getMarkerIdFromPrefixedId } from './utils';
import { StatusMessageService } from "../status-message.service";
import { TabService } from "../../tab.service";
import { finalize } from 'rxjs/operators';

const MARKER_SPINNER = 'marker-data';


declare function generateRandomHexColor(): any;

@Injectable({
    providedIn: 'root'
})


export class MarkersService {
    urlLoadMarkersData = environment.apiURL + 'load_markers_data';
    urlLoadInitializdMarkersData = environment.apiURL + 'load_initialized_markers_data';
    urlLoadMarkerFish = environment.apiURL + 'load_marker_fish';

    subjectIsMarkersDataLoaded = new BehaviorSubject<boolean>(false);
    subjectIsInitialMarkersDataLoaded = new BehaviorSubject(false);
    subjectIsSelectedMarkersList = new BehaviorSubject([]);

    markersData;
    public isMarkersDataLoaded = false;
    isInitialMarkersDataLoaded = false;
    private isLoadingInitialData = false;
    isInitialMarkersDataGotSelected = false;
    isSplit = true;
    favouriteMarkersIDs = [];

    selectedFilteredTypesList = [];
    selectedFilteredCatsList = [];
    selectedFilteredLabsList = [];
    subjectOnMarkersFiltersSelected = new BehaviorSubject(false);
    //This variable only to check its length to know if we have a selected fish in the Atlas generally. But we will not use it to get any fish information
    selectedFish = [];

    initialMarkersIDs;
    tempInitialMarkersDictionary;


    constructor(private httpService: HttpService,
        private twoDService: TwoDService,
        private userService: UserService,
        private spinner: NgxSpinnerService,
        private markersColorsService: MarkersColorsService,
        private atlasSharedService: AtlasSharedService,
        private alertService: AlertService,
        private statusMessageService: StatusMessageService,
        private tabService: TabService
    ) { }

    resetInitialMarkersData() {
        this.isInitialMarkersDataLoaded = false;
        this.isLoadingInitialData = false;
        this.isInitialMarkersDataGotSelected = false;
    }

    loadMarkersData(): void {
        if (!this.isMarkersDataLoaded) {
            this.spinner.show(MARKER_SPINNER);

            this.httpService.postRequest(this.urlLoadMarkersData, {
                exclude_ids: [
                    ...new Set([
                        ...this.atlasSharedService.sharedViewItems.markers.ids,
                        ...this.initialMarkersIDs
                    ])
                ]
            }).pipe(
                finalize(() => this.spinner.hide(MARKER_SPINNER))
            ).subscribe((response) => {
                const temp = response['data'];

                this.markersData.dictionary = Object.assign({}, this.markersData.dictionary, temp.dictionary);

                this.markersData.IDs = Object.keys(this.markersData.dictionary).sort((a, b) => {
                    const markerA = this.markersData.dictionary[a];
                    const markerB = this.markersData.dictionary[b];

                    const isSelectedA = markerA?.selected ? 1 : 0;
                    const isSelectedB = markerB?.selected ? 1 : 0;

                    // Primary sorting: selected markers first
                    if (isSelectedB - isSelectedA !== 0) {
                        return isSelectedB - isSelectedA;
                    }

                    // Secondary sorting: alphabetically by marker name
                    return markerA.name.localeCompare(markerB.name);
                });

                this.markersData.types = temp.types;
                this.markersData.labs = temp.labs;
                this.markersData.categories = temp.categories;

                if (this.userService._isUserAuthenticated) {
                    this.setFavouriteMarkers(this.userService.user.saved_data.favourite_markers_ids);
                }

                this.isMarkersDataLoaded = true;
                this.subjectIsMarkersDataLoaded.next(this.isMarkersDataLoaded);
            });
        }
    }


    reloadMarkersData(): Observable<boolean> {
        this.isMarkersDataLoaded = false;
        this.subjectIsMarkersDataLoaded.next(this.isMarkersDataLoaded);


        return new Observable(observer => {
            this.loadMarkersData(); // Trigger loading

            this.subjectIsMarkersDataLoaded.subscribe(isLoaded => {
                if (isLoaded) {
                    observer.next(true);
                    observer.complete();
                }
            });
        });
    }

    loadInitialMarkersData(): Promise<void> {
        if (this.isInitialMarkersDataLoaded || this.isLoadingInitialData) {
            return Promise.resolve(); // Already loaded
        }

        this.isLoadingInitialData = true;
        this.spinner.show();

        return new Promise<void>((resolve, reject) => {
            this.httpService.postRequest(this.urlLoadInitializdMarkersData, {}).subscribe({
                next: (response) => {
                    this.markersData = response['data'];
                    this.markersData.selectedMarkersList = [];

                    this.initialMarkersIDs = response['data']['IDs'];
                    this.tempInitialMarkersDictionary = response['data']['dictionary'];

                    this.isInitialMarkersDataLoaded = true;
                    this.subjectIsInitialMarkersDataLoaded.next(true);

                    resolve();
                },
                error: (error) => {
                    console.error("Error loading initial markers data:", error);
                    this.subjectIsInitialMarkersDataLoaded.next(false);
                    reject(error);
                },
                complete: () => {
                    this.isLoadingInitialData = false;
                    this.spinner.hide();
                }
            });
        });
    }



    getMarkerFish(marker) {
        this.httpService.postRequest(this.urlLoadMarkerFish, { lineId: marker.id })
            .subscribe(retrievedFishData => {
                marker.fish = retrievedFishData.fish;
                for (let i = 0; i < marker.fish.length; i++) {
                    let fish = marker.fish[i];
                    let marker_id = marker.id;
                    this.initMarkerFish2DDrawingProperties(fish);
                    if (this.atlasSharedService.sharedViewItems.markers.fishDictionary[marker_id] !== undefined) {
                        if (this.atlasSharedService.sharedViewItems.markers.fishDictionary[marker_id]['ids'].includes(fish.id)) {
                            let index = this.atlasSharedService.sharedViewItems.markers.fishDictionary[marker_id]['index'];
                            fish.selected = true;
                            this.onFishSelectionChanged(marker, fish);
                            fish.drawingInfo.enhancement = this.atlasSharedService.sharedViewItems.markers.fishDictionary[marker_id]['enhancement'][index];
                            fish.drawingInfo.color = this.atlasSharedService.sharedViewItems.markers.fishDictionary[marker_id]['color'][index];
                            this.atlasSharedService.sharedViewItems.markers.fishDictionary[marker_id]['index'] += 1;
                            this.twoDService.updateScene();
                        }
                    }
                }

            }, error => {
                this.alertService.showErrorMsg('SOMETHING_WENT_WRONG');
            });
    }

    async selectInitialMarkers(): Promise<void> {
        if (!this.isInitialMarkersDataGotSelected) {
            for (const id of this.initialMarkersIDs) {
                const marker = this.tempInitialMarkersDictionary[id];
                this.selectMarker(marker, false);
            }
            this.isInitialMarkersDataGotSelected = true;
            await this.twoDService.updateScene();
        }
    }

    getMarkerDataByID(markerID: number) {
        return this.markersData.dictionary[markerID];
    }


    onMarkersSelectionChanged(marker) {
        if (marker.selected) {
            this.selectMarker(marker, true);
        } else {
            this.deselectMarker(marker, true);
        }
    }

    onMarkerShowChanged(marker) {
        if (marker.show) {
            this.showMarkerFrom2DScene(marker, true);
        } else {
            this.hideMarkerFrom2DScene(marker, true);
        }
    }

    selectMarker(marker, isUpdate) {
        this.spinner.show();
        marker.selected = true;
        marker.show = true;

        this.initMarker2DDrawingProperties(marker);
        this.getMarkerFish(marker);
        this.markersData.selectedMarkersList = [...this.markersData.selectedMarkersList, marker];
        this.subjectIsSelectedMarkersList.next(this.markersData.selectedMarkersList);
        this.addMarkerTo2DScene(marker, isUpdate);
        this.spinner.hide();
    }

    onFishSelectionChanged(marker, fish) {
        if (fish.selected) {
            if (marker.selectedFish === undefined || marker.selectedFish === null) {
                marker.selectedFish = [];
            }
            marker.selectedFish.push(fish);
            this.selectedFish.push(fish);
            this.selectFish(fish, marker, true);
        } else {
            let index = marker.selectedFish.indexOf(fish);
            let index_temp = this.selectedFish.indexOf(fish);
            marker.selectedFish.splice(index, 1);
            this.selectedFish.splice(index_temp, 1);
            this.deselectFish(fish, marker, true);
        }
    }

    selectFish(fish, marker, isUpdate) {
        this.spinner.show();

        fish.selected = true;
        fish.show = true;

        this.initMarker2DDrawingProperties(fish);
        this.twoDService.addFishImageTo2DScene(marker.id, fish.drawingInfo, isUpdate);
        this.spinner.hide();
    }

    deselectMarker(marker, isUpdate) {
        marker.selected = false;
        marker.show = false;

        if (marker.drawingInfo != undefined && marker.drawingInfo.color != null) {
            this.markersColorsService.freeLineColor(marker.drawingInfo.color);
        }

        const initialLength = this.markersData.selectedMarkersList.length;
        this.markersData.selectedMarkersList = this.markersData.selectedMarkersList.filter(m => m.id !== marker.id);
        // Only notify and update scene if an item was actually removed
        if (this.markersData.selectedMarkersList.length < initialLength) {
            this.subjectIsSelectedMarkersList.next(this.markersData.selectedMarkersList);
            this.removeMarkerFrom2DScene(marker, isUpdate);
        }

        marker.drawingInfo = null;
    }

    deselectFish(fish, marker, isUpdate) {
        fish.selected = false;
        fish.show = false;

        this.twoDService.removeFishImageFrom2DScene(fish, marker.id, isUpdate);
    }

    async deselectAllMarkers() {
        this.subjectIsSelectedMarkersList.next([]);

        if (this.markersData && this.markersData.selectedMarkersList) {
            const markersToDeselect = [...this.markersData.selectedMarkersList];
            if (markersToDeselect.length > 0) {
                for (const marker of markersToDeselect) {
                    this.deselectMarker(marker, false);
                }
                await this.twoDService.updateScene();
            }
        }
    }

    initMarker2DDrawingProperties(marker) {
        if (marker.drawingInfo === undefined || marker.drawingInfo === null) {
            if (!this.atlasSharedService.sharingCurrentViewStatus.hash) {
                marker.drawingInfo = new ImageDrawingInfo(marker.visualization_data._2d, this.markersColorsService.getLineColor(), false);
            } else {
                marker.drawingInfo = new ImageDrawingInfo(marker.visualization_data._2d, this.markersColorsService.getLineColorOfShareView(), false);
                //Set the share view enhancement value of the current marker
                let index = marker['shareViewIndexOfMarker']
                if (this.atlasSharedService.sharedViewItems.markers.enhancement[index]) {
                    marker.drawingInfo.enhancement = this.atlasSharedService.sharedViewItems.markers.enhancement[index];
                    this.twoDService.updateScene();
                }
            }

        }
    }

    initMarkerFish2DDrawingProperties(fish) {
        if (fish.drawingInfo === undefined || fish.drawingInfo === null) {
            fish.drawingInfo = new ImageDrawingInfo(fish.visualization_data._2d, generateRandomHexColor(), false);
        }
    }

    addMarkerTo2DScene(marker, isUpdate) {
        // this.twoDService.addImageTo2DScene(this.isSplit, marker.drawingInfo, isUpdate);
        this.twoDService.addMarkerTo2DScene(marker.id, marker.drawingInfo, isUpdate);
    }

    removeMarkerFrom2DScene(marker, isUpdate) {
        // this.twoDService.removeImageFrom2DScene(this.isSplit, marker.drawingInfo, isUpdate);
        this.twoDService.removeMarkerFrom2DScene(marker.id, isUpdate);
    }

    hideMarkerFrom2DScene(marker, isUpdate) {
        // this.twoDService.removeImageFrom2DScene(this.isSplit, marker.drawingInfo, isUpdate);
        this.twoDService.removeMarkerAverageImageFrom2DScene(marker.id, isUpdate);
    }

    showMarkerFrom2DScene(marker, isUpdate) {
        // this.twoDService.removeImageFrom2DScene(this.isSplit, marker.drawingInfo, isUpdate);
        this.twoDService.addMarkerAverageTo2DScene(marker.id, marker.drawingInfo, isUpdate);
    }

    // initializeMarkersCategories() {
    //     for (let i = 0; i < this.markersData.categories.length; i++) {
    //         let categoryID = this.markersData.categories[i]['id'];
    //         this.markersData.categorizedMarkersData[categoryID] = [];
    //         for (let j = 0; j < this.markersData.categorizedMarkersIDs[categoryID].length; j++) {
    //             let markerID = this.markersData.categorizedMarkersIDs[categoryID][j];
    //             this.markersData.categorizedMarkersData[categoryID].push(this.markersData.dictionary[markerID]);
    //         }
    //     }
    // }

    setFavouriteMarkers(userFavouriteMarkersIDs) {
        this.favouriteMarkersIDs = [];
        if (this.markersData !== undefined) {
            for (let i = 0; i < this.markersData.IDs.length; i++) {
                let markerID = this.markersData.IDs[i];
                let markerData = this.getMarkerDataByID(markerID);
                if (userFavouriteMarkersIDs.indexOf(markerData.id) > -1) {
                    markerData.isFavourite = true;
                    this.favouriteMarkersIDs.push(getMarkerIdFromPrefixedId(markerID));
                } else {
                    markerData.isFavourite = false;
                }
            }
        }
    }

    getSelectedMarkersDataShareView() {
        let data = [];
        let index = 0;
        for (let i = 0; i < this.markersData.selectedMarkersList.length; i++) {
            let marker = this.markersData.selectedMarkersList[i];
            if (marker.show) {
                data.push({
                    id: marker.id,
                    color: marker.drawingInfo.color,
                    enhancement: marker.drawingInfo.enhancement,
                    fish: { ids: [], enhancement: [], color: [] }
                })
                for (let j = 0; j < marker.fish.length; j++) {
                    let fish = marker.fish[j];
                    if (fish.selected) {
                        data[index]['fish']['ids'].push(fish.id);
                        data[index]['fish']['enhancement'].push(fish.drawingInfo.enhancement);
                        data[index]['fish']['color'].push(fish.drawingInfo.color);
                    }
                }
                index += 1;
            }
        }
        return data;
    }

    setShareViewFishData(marker_id, fishDictionary) {
        this.atlasSharedService.sharedViewItems.markers.fishDictionary[marker_id] = {
            'ids': [],
            'enhancement': [],
            'color': [],
        };
        this.atlasSharedService.sharedViewItems.markers.fishDictionary[marker_id]['ids'] = fishDictionary[marker_id]['ids'];
        this.atlasSharedService.sharedViewItems.markers.fishDictionary[marker_id]['enhancement'] = fishDictionary[marker_id]['enhancement'];
        this.atlasSharedService.sharedViewItems.markers.fishDictionary[marker_id]['color'] = fishDictionary[marker_id]['color'];
        this.atlasSharedService.sharedViewItems.markers.fishDictionary[marker_id]['index'] = 0;
    }

    async loadSelectedMarkersShareView(markersResponse) {
        return new Promise<void>(async (resolve, reject) => {
            this.deselectAllMarkers();
            this.atlasSharedService.sharedViewItems.markers.ids = []
            this.atlasSharedService.sharedViewItems.markers.ids = markersResponse['ids'];
            let colors = markersResponse['colors'];
            let fishDictionary = markersResponse['fish_dictionary'];
            this.atlasSharedService.sharedViewItems.markers.enhancement = markersResponse['enhancement'];
            let temp = markersResponse['preset_markers_data'];

            //Push the new chosen markers to the Initial predefined markers IDS(it is already set before in loadInitialMarkersData func)
            Array.prototype.push.apply(this.markersData.IDs, temp.IDs);
            this.markersData.dictionary = Object.assign({}, this.markersData.dictionary, temp.dictionary);
            this.markersColorsService.setLineColorOfShareView(colors);
            if (this.atlasSharedService.sharedViewItems.markers.ids.length) {
                this.tabService.openMarkersTab();
                await this.statusMessageService.updateStatus("Start loading markers", true, true, 2000);
                for (let i = 0; i < this.atlasSharedService.sharedViewItems.markers.ids.length; i++) {
                    let marker_id = this.atlasSharedService.sharedViewItems.markers.ids[i];
                    this.setShareViewFishData(marker_id, fishDictionary);
                    this.markersData.dictionary[marker_id]['shareViewIndexOfMarker'] = i;
                    this.selectMarker(this.markersData.dictionary[marker_id], false)
                }
            }

            await this.twoDService.updateScene();
            resolve();
            // Perform the asynchronous task
            // Call resolve() when the task is complete, or reject(error) if there's an error
        });


    }

    isSelectedMarkersHidden(selectedMarkersLength) {
        let markersLength = selectedMarkersLength;
        for (let j = 0; j < selectedMarkersLength; j++) {
            if (!this.markersData.selectedMarkersList[j].show) {
                markersLength -= 1;
            }
        }
        return markersLength == 0;
    }

    getSelectedLabs() {
        let selectedLabs = '';
        for (let i = 0; i < this.selectedFilteredLabsList.length; i++) {
            if (i < this.selectedFilteredLabsList.length - 1) {
                selectedLabs += this.selectedFilteredLabsList[i].name + ", ";
            } else {
                selectedLabs += this.selectedFilteredLabsList[i].name + ".";
            }
        }
        return selectedLabs;
    }

    getSelectedTypes() {
        let selectedTypes = '';
        for (let i = 0; i < this.selectedFilteredTypesList.length; i++) {
            if (i < this.selectedFilteredTypesList.length - 1) {
                selectedTypes += this.selectedFilteredTypesList[i].name + ", ";
            } else {
                selectedTypes += this.selectedFilteredTypesList[i].name + ".";
            }
        }
        return selectedTypes;
    }

    getSelectedCats() {
        let selectedCats = '';
        for (let i = 0; i < this.selectedFilteredCatsList.length; i++) {
            if (i < this.selectedFilteredCatsList.length - 1) {
                selectedCats += this.selectedFilteredCatsList[i].name + ", ";
            } else {
                selectedCats += this.selectedFilteredCatsList[i].name + ".";
            }
        }
        return selectedCats;
    }

}
